import React from 'react';
import { offer } from '../data/offer';
import { pad, useDeadlineCountdown } from '../hooks/useDeadlineCountdown';
type Props = {
  variant: 'compact' | 'boxes';
};

/** Renders nothing when no real closing date is configured or it has passed. */
export function OfferCountdown({
  variant
}: Props) {
  const timeLeft = useDeadlineCountdown(offer.closesAt);
  if (!timeLeft) return null;
  if (variant === 'compact') {
    return <span className="font-mono font-bold tabular-nums bg-white/15 rounded px-1.5 py-0.5 text-white" data-id="element-155" data-mp="1c9g4pvilsfet">
        {timeLeft.days > 0 && `${timeLeft.days}d `}
        {pad(timeLeft.hours)}:{pad(timeLeft.minutes)}:{pad(timeLeft.seconds)}
      </span>;
  }
  const units = [...(timeLeft.days > 0 ? [{
    value: timeLeft.days,
    label: 'Días'
  }] : []), {
    value: timeLeft.hours,
    label: 'Horas'
  }, {
    value: timeLeft.minutes,
    label: 'Min'
  }, {
    value: timeLeft.seconds,
    label: 'Seg'
  }];
  return <div className="flex items-start justify-center gap-2 md:gap-3" role="timer" aria-live="off" data-id="element-156" data-mp="31li1d9u5gbjj">
      {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-157" data-mp="21q6uhemyr6l4">
          <div className="bg-brand-purpleDark text-white font-mono font-bold text-2xl md:text-3xl rounded-xl min-w-[58px] md:min-w-[72px] px-2 py-2 md:py-3 text-center tabular-nums border border-brand-gold/40" data-id="element-158" data-mp="21ovrvi5984vl">
            {pad(unit.value)}
          </div>
          <span className="text-[11px] md:text-xs font-medium text-brand-muted mt-1.5 uppercase tracking-wider" data-id="element-159" data-mp="1nrqoxr0u7m4k">
            {unit.label}
          </span>
        </div>)}
    </div>;
}